// @generated by protoc-gen-es v1.7.2
// @generated from file proctoring/v1/events.proto (package proctoring.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { Session_Key } from "./session_pb.js";

/**
 * @generated from message proctoring.v1.EventServiceNewRequest
 */
export const EventServiceNewRequest = proto3.makeMessageType(
  "proctoring.v1.EventServiceNewRequest",
  () => [
    { no: 1, name: "session_key", kind: "message", T: Session_Key },
    { no: 2, name: "events", kind: "message", T: Event, repeated: true },
  ],
);

/**
 * @generated from message proctoring.v1.EventServiceNewResponse
 */
export const EventServiceNewResponse = proto3.makeMessageType(
  "proctoring.v1.EventServiceNewResponse",
  [],
);

/**
 * @generated from message proctoring.v1.EventServiceGetRequest
 */
export const EventServiceGetRequest = proto3.makeMessageType(
  "proctoring.v1.EventServiceGetRequest",
  () => [
    { no: 1, name: "session_key", kind: "message", T: Session_Key },
  ],
);

/**
 * @generated from message proctoring.v1.EventServiceGetResponse
 */
export const EventServiceGetResponse = proto3.makeMessageType(
  "proctoring.v1.EventServiceGetResponse",
  () => [
    { no: 1, name: "event", kind: "message", T: Event },
  ],
);

/**
 * @generated from message proctoring.v1.Event
 */
export const Event = proto3.makeMessageType(
  "proctoring.v1.Event",
  () => [
    { no: 1, name: "number", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "time", kind: "message", T: Timestamp },
    { no: 3, name: "assessment_start", kind: "message", T: Event_AssessmentStart, oneof: "event" },
    { no: 4, name: "assessment_end", kind: "message", T: Event_AssessmentEnd, oneof: "event" },
    { no: 5, name: "key_press", kind: "message", T: Event_KeyPress, oneof: "event" },
    { no: 6, name: "displays", kind: "message", T: Event_Displays, oneof: "event" },
    { no: 7, name: "connection", kind: "message", T: Event_Connection, oneof: "event" },
    { no: 8, name: "microphone_audio", kind: "message", T: Event_MicrophoneAudio, oneof: "event" },
    { no: 9, name: "object_detection", kind: "message", T: Event_ObjectDetection, oneof: "event" },
    { no: 10, name: "face_detection", kind: "message", T: Event_FaceDetection, oneof: "event" },
  ],
);

/**
 * @generated from message proctoring.v1.Event.AssessmentStart
 */
export const Event_AssessmentStart = proto3.makeMessageType(
  "proctoring.v1.Event.AssessmentStart",
  [],
  {localName: "Event_AssessmentStart"},
);

/**
 * @generated from message proctoring.v1.Event.AssessmentEnd
 */
export const Event_AssessmentEnd = proto3.makeMessageType(
  "proctoring.v1.Event.AssessmentEnd",
  [],
  {localName: "Event_AssessmentEnd"},
);

/**
 * @generated from message proctoring.v1.Event.KeyPress
 */
export const Event_KeyPress = proto3.makeMessageType(
  "proctoring.v1.Event.KeyPress",
  () => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
  {localName: "Event_KeyPress"},
);

/**
 * @generated from message proctoring.v1.Event.Displays
 */
export const Event_Displays = proto3.makeMessageType(
  "proctoring.v1.Event.Displays",
  () => [
    { no: 1, name: "count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
  {localName: "Event_Displays"},
);

/**
 * @generated from message proctoring.v1.Event.DisplayRecording
 */
export const Event_DisplayRecording = proto3.makeMessageType(
  "proctoring.v1.Event.DisplayRecording",
  [],
  {localName: "Event_DisplayRecording"},
);

/**
 * @generated from message proctoring.v1.Event.UserMediaRecording
 */
export const Event_UserMediaRecording = proto3.makeMessageType(
  "proctoring.v1.Event.UserMediaRecording",
  [],
  {localName: "Event_UserMediaRecording"},
);

/**
 * @generated from message proctoring.v1.Event.Connection
 */
export const Event_Connection = proto3.makeMessageType(
  "proctoring.v1.Event.Connection",
  () => [
    { no: 1, name: "connected", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "Event_Connection"},
);

/**
 * @generated from message proctoring.v1.Event.MicrophoneAudio
 */
export const Event_MicrophoneAudio = proto3.makeMessageType(
  "proctoring.v1.Event.MicrophoneAudio",
  [],
  {localName: "Event_MicrophoneAudio"},
);

/**
 * @generated from message proctoring.v1.Event.ObjectDetection
 */
export const Event_ObjectDetection = proto3.makeMessageType(
  "proctoring.v1.Event.ObjectDetection",
  () => [
    { no: 1, name: "rekognition", kind: "message", T: Event_ObjectDetection_Rekognition, oneof: "algorithm" },
  ],
  {localName: "Event_ObjectDetection"},
);

/**
 * @generated from message proctoring.v1.Event.ObjectDetection.Rekognition
 */
export const Event_ObjectDetection_Rekognition = proto3.makeMessageType(
  "proctoring.v1.Event.ObjectDetection.Rekognition",
  () => [
    { no: 1, name: "labels", kind: "message", T: Event_ObjectDetection_Rekognition_Label, repeated: true },
  ],
  {localName: "Event_ObjectDetection_Rekognition"},
);

/**
 * @generated from message proctoring.v1.Event.ObjectDetection.Rekognition.Label
 */
export const Event_ObjectDetection_Rekognition_Label = proto3.makeMessageType(
  "proctoring.v1.Event.ObjectDetection.Rekognition.Label",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "confidence", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ],
  {localName: "Event_ObjectDetection_Rekognition_Label"},
);

/**
 * @generated from message proctoring.v1.Event.FaceDetection
 */
export const Event_FaceDetection = proto3.makeMessageType(
  "proctoring.v1.Event.FaceDetection",
  [],
  {localName: "Event_FaceDetection"},
);

